var text_field_default = {
  "root": "zFD9Z",
  "text": "fpk6K",
  "input": "NVIeg",
  "small": "TWWQE",
  "medium": "cSKPd",
  "large": "We5Vw",
  "webview": "C8reo",
  "endAdornment": "kuEgf",
  "shown": "geO1M",
  "value": "Izbnu",
  "spinner": "cXPiW",
  "spin": "_8NwNW"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
